import React from 'react'
import { ControlledSelectField } from '../ControlledSelectField'

export const BrandTypeSelect = () => {
  const brandTypeMenuItems = [
    { value: 'BRAND', label: 'Brand' },
    { value: 'AGENCY', label: 'Agency' },
    { value: 'CONSULTANT', label: 'Consultant' }
  ]

  return (
    <ControlledSelectField
      name='brandType'
      label='I am a'
      menuItems={brandTypeMenuItems}
    />
  )
}
